'use strict';

// @flow

var UserUtils = {

  createUser: function createUser(updates, timestamp, user //: { id: string, country: string, fullName: string, displayName: string }
  ) {
    updates['users/' + user.id + '/screens/onboarding'] = true;
    updates['users/' + user.id + '/screens/inviteCoworkers'] = user.onboardingSource === 'web';

    var index = user.id.indexOf(' ');
    var countryCode = user.id.substr(0, index);
    var phoneNumber = user.id.substr(index + 1);
    updates['users/' + user.id + '/metadata'] = {
      id: user.id,
      areaCode: countryCode,
      country: user.country,
      phoneNumber: phoneNumber,
      fullName: user.fullName,
      displayName: user.displayName,
      creationTimestamp: timestamp,
      email: user.email
    };

    return updates;
  }
};

module.exports = UserUtils;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fibo-app/fibo-collab-shared/build/UserUtils.js
// module id = 172
// module chunks = 0